import React from 'react'
import styles from './CreateAcount.module.css'
import mainlogo from '../Images/Mainlogo.svg'

const CreateAcount = () => {
    return (
        <>

            <div className={styles.create}>
                <div className={styles.inputArea}>
                    <div className={styles.form}>
                        <div className={styles.formNmae}>
                            <div className={styles.formHeading}>Name</div>
                           <input type="text" placeholder='Placeholder text' className={styles.innerInput} />
                        </div>
                        <div className={styles.formNmae}>
                            <div className={styles.formHeading} style={{ marginTop: "43px" }}>Your business email</div>
                            <input type="text" placeholder='Placeholder text' className={styles.innerInput} />
                        </div>
                        <div className={styles.formNmae}>
                            <div className={styles.formHeading} style={{ marginTop: "43px" }}>Password</div>
                            <input type="text" placeholder='Placeholder text' className={styles.innerInput} />
                        </div>
                        <div className={styles.formNmae}>
                            <div className={styles.formHeading} style={{ marginTop: "43px" }}>Repeat Password</div>
                           <input type="text" placeholder='Placeholder text' className={styles.innerInput} />
                        </div>
                        <div className={styles.already} style={{ marginTop: "43px" }}>I already have a user account</div>
                    </div>
                </div>
                <div className={styles.portal}>
                    <img src={mainlogo} className={styles.mainlogo} alt="" />
                    <div className={styles.metrics}>MapMetrics</div>
                    <div className={styles.lowerText}>Bussiness Portal</div>
                </div>
            </div>
        </>
    )
}

export default CreateAcount
